module.exports = __webpack_public_path__ + "img/ico_delivery_fixed.20d04ea.svg";